import { render, staticRenderFns } from "./PatShipment.vue?vue&type=template&id=2cbcd7c3&scoped=true"
import script from "./PatShipment.vue?vue&type=script&lang=js"
export * from "./PatShipment.vue?vue&type=script&lang=js"
import style0 from "./PatShipment.vue?vue&type=style&index=0&id=2cbcd7c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbcd7c3",
  null
  
)

export default component.exports